/**
 * Created by rhett on 2019/4/12.
 */

import React, {Component} from 'react';
import "./JoinPage.css";
import LoginPanel from "./LoginPanel";
import App from './App';

export default class JoinPage extends Component
{
constructor(props){
  super(props);
  this.state={time:0,name:"",age:0,community:""};

}

  componentWillMount()
  {
    LoginPanel.verifyLogin(this.loadData.bind(this))
  }
  componentDidMount()
  {
    window.scrollTo(0,0);
  }

  loadData()
  {
  }

  render()
  {
    window.document.title = "确认提交";

    let actId = this.props.match.params.id;
    actId = parseInt(actId);

    if (actId == 1)
    {
      return (
        <div className="JoinPage">
          <div className="content">
            <h1>画画课程</h1>
            <p className="fieldTf"><img src={require("./h5_icon_bigtime_normal.png")} alt=""/>4月25日起 每周四16:00-17:00</p>
            <p className="fieldTf"><img src={require("./h5_icon_local_normal.png")} alt=""/>共和新路街道社区群团服务中心（平型关路471号）</p>

          </div>

          <div className="hr2" style={{marginTop: '20px'}}></div>

          <div className="row content">
            <h2>报名人数</h2>
            <div className="right">1人</div>
          </div>
          <div className="hr1"></div>

          <div className="content">
            <h2>报名信息</h2>
          </div>
          <div className="row content">
            <p>你的姓名：</p>
            <div className="right">
              <input type="text" name="" id="" placeholder="请输入真实姓名"
                     onChange={(e) =>
              {
                this.setState({name: e.target.value});
              }}/>
            </div>
          </div>
          <div className="hr1"></div>
          <div className="row content">
            <p>所属居委：</p>
            <div className="right">
              <select placeholder="请选择 〉"
                      defaultValue=""
                      className={this.state.community ?"":"placeholder"}
                      onChange={(e) =>
              {
                this.setState({community: e.target.value});
              }}>
                <option value=""  disabled>请选择 〉</option>
                <option value="柳  一">柳 一</option>
                <option value="柳  二">柳 二</option>
                <option value="洛  川">洛 川</option>
                <option value="洛  平">洛 平</option>
                <option value="锦  灏">锦 灏</option>
                <option value="延  新">延 新</option>
                <option value="嘉  利">嘉 利</option>
                <option value="三  阳">三 阳</option>
                <option value="和  乐">和 乐</option>
                <option value="申  地">申 地</option>
                <option value="唐家沙">唐家沙</option>
                <option value="柳营桥">柳营桥</option>
                <option value="805 弄">805 弄</option>
                <option value="新理想">新理想</option>
                <option value="80 弄">80 弄</option>
                <option value="谈家桥">谈家桥</option>
                <option value="家豪城">家豪城</option>
                <option value="899 弄">899 弄</option>
                <option value="1100弄">1100弄</option>
                <option value="沪  北">沪 北</option>
                <option value="谈家宅">谈家宅</option>
                <option value="锦佳苑">锦佳苑</option>
                <option value="永  乐">永 乐</option>
                <option value="洛  善">洛 善</option>
                <option value="727 弄">727 弄</option>
              </select>
            </div>
          </div>
          <div className="hr1"></div>

          <div className="row content">
            <p>儿童年龄：</p>
            <p className="right">
              <select placeholder="请选择 〉"
                      className={this.state.age ?"":"placeholder"}
                      defaultValue={0}
                      onChange={(e) =>
                      {
                        this.setState({age: e.target.value});
                      }}>
                <option value="0"  disabled>请选择 〉</option>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
                <option value="6">6</option>
                <option value="7">7</option>
                <option value="8">8</option>
                <option value="9">9</option>
                <option value="10">10</option>
                <option value="11">11</option>
                <option value="12">12</option>
                <option value="13">13</option>
                <option value="14">14</option>
                <option value="15">15</option>
                <option value="16">16</option>
                <option value="17">17</option>
                <option value="18">18</option>
              </select>
            </p>
          </div>


          <div className=" endBg" style={{paddingTop: '10px'}}>
            <p className="content note">个人信息仅供街道办审核活动使用，不作其他任何商业用途。</p>
          </div>

          <a onClick={this.onSubmit.bind(this)} className="bottomBigBtn stickFooter">确认提交</a>


        </div>);
    } else
    {
      return (
        <div className="JoinPage">
          <div className="content">
            <h1>瑜伽课程</h1>
            <p className="fieldTf"><img src={require("./h5_icon_bigtime_normal.png")} alt=""/>4月25日起 每周四16:00-17:00 每周六10:00-11:00</p>
            <p className="fieldTf"><img src={require("./h5_icon_local_normal.png")} alt=""/>共和新路街道社区党建服务中心（平型关路471号）</p>

          </div>

          <div className="hr2" style={{marginTop: '20px'}}></div>

          <div className="row content">
            <h2>报名人数</h2>
            <div className="right">1人</div>
          </div>
          <div className="hr1"></div>

          <div className="content">
            <h2>报名信息</h2>
          </div>
          <div className="row content">
            <p>你的姓名：</p>
            <div className="right">
              <input type="text" name="" id="" placeholder="请输入真实姓名" onChange={(e) =>
              {
                this.setState({name: e.target.value});
              }}/>
            </div>
          </div>
          <div className="hr1"></div>
          <div className="row content">
            <p>所属居委：</p>
            <div className="right">
              <select placeholder="请选择 〉"
                      defaultValue=""
                      className={this.state.community ?"":"placeholder"}
                      onChange={(e) =>
              {
                this.setState({community: e.target.value});
              }}>
                <option value=""  disabled>请选择 〉</option>

                <option value="柳  一">柳 一</option>
                <option value="柳  二">柳 二</option>
                <option value="洛  川">洛 川</option>
                <option value="洛  平">洛 平</option>
                <option value="锦  灏">锦 灏</option>
                <option value="延  新">延 新</option>
                <option value="嘉  利">嘉 利</option>
                <option value="三  阳">三 阳</option>
                <option value="和  乐">和 乐</option>
                <option value="申  地">申 地</option>
                <option value="唐家沙">唐家沙</option>
                <option value="柳营桥">柳营桥</option>
                <option value="805 弄">805 弄</option>
                <option value="新理想">新理想</option>
                <option value="80 弄">80 弄</option>
                <option value="谈家桥">谈家桥</option>
                <option value="家豪城">家豪城</option>
                <option value="899 弄">899 弄</option>
                <option value="1100弄">1100弄</option>
                <option value="沪  北">沪 北</option>
                <option value="谈家宅">谈家宅</option>
                <option value="锦佳苑">锦佳苑</option>
                <option value="永  乐">永 乐</option>
                <option value="洛  善">洛 善</option>
                <option value="727 弄">727 弄</option>
              </select>
            </div>
          </div>
          <div className="hr1"></div>

          <div className="row content">
            <p>你的年龄：</p>
            <p className="right">
              <input type="text" name="" id="" placeholder="请输入年龄" onChange={(e) =>
              {
                this.setState({age: parseInt(e.target.value)});
              }}/>

            </p>
          </div>

          <div className="hr1"></div>

          <div className="row content">
            <p>上课时间：</p>
            <p className="right">
              <select placeholder="请选择 〉"
                      defaultValue={0}
                      className={this.state.time ?"":"placeholder"}
                      onChange={(e) =>
                      {
                        this.setState({time: e.target.value});
                      }}>
                <option value="0"  disabled>请选择 〉</option>
                <option value="4">周四16：00～17：00</option>
                <option value="6">周六10：00～11：00</option>
              </select>
            </p>
          </div>


          <div className=" endBg" style={{paddingTop: '10px'}}>
            <p className="content note">个人信息仅供街道办审核活动使用，不作其他任何商业用途。</p>
          </div>

          <a onClick={this.onSubmit.bind(this)} className="bottomBigBtn stickFooter">确认提交</a>


        </div>);

    }
  }


  onSubmit()
  {
    let {name, community, age, time} = this.state;
    let actId = this.props.match.params.id;
    actId = parseInt(actId);
    if (!name)
    {
      alert("请填写姓名");
      return;
    }
    if (!age)
    {
      alert("请填写年龄");
      return;
    }
    if (!community)
    {
      alert("请填写所属区委");
      return;
    }

    let members = [{name, age, community}];
    App.gw.gwJoin(actId, JSON.stringify(members),time, (data) =>
    {
      if (data.orderId)
      {
        alert("提交成功，等待审核中，审核成功即可参加活动喔");
        this.props.history.replace(`./detail-${actId}`);
      }
    });

  }

}

